import React, { useEffect, useState } from 'react'
import UsiDetailsForm from '../tags/UsiDetailsForm'
import parse from 'html-react-parser';
import { getHelperTextForPage, getTemporaryCustomMessages } from '../../services/reservoir'
import { getStudentProgress, getSonePersonalDetails, getUsiDetails, putUsiDetails } from '../../services/vu'
import { getStepByIndex, getStepIndexByUrl, updateDBStepProgress, updateStepProgress } from '../../helpers/steps'
import { getCourseId } from '../../helpers/course'
import Loading from '../tags/Loading'
import { differenceInSeconds } from 'date-fns'
import { getLastPageAccessTime } from '../../helpers/gtm'
import { getAttributeCourseStaticInfo } from '../../helpers/enrolment'
import Error from './Error'
import { ErrorCard } from '../tags/ErrorCard';
import { Notifications } from '@mui/icons-material';

const UsiDetails = props => {
  const [formLoaded, setFormLoaded] = useState(false)
  const [formFailedLoading, setFormFailedLoading] = useState(false)
  const [saving, setSaving] = useState(false)
  const [topCallout, setTopCallout] = useState('')
  const [usiVerificationSuccess, setUsiVerificationSuccess] = useState(false)
  const [tempMessage, setTempMessage] = useState(null);
  const [form, setForm] = useState({
    dateOfBirth: '',
    singleName: '',
    firstName: '',
    familyName: '',
    usiNo: '',
    firstFamilyNameIndicator: 'N',
    usiVerified: false,
    gender: '',
    internationalStudentNotYetArrived: '',
    hasErrorOnValidation: false,
    showValidationMessage: false
  })

  useEffect(()=> {
    Promise.all([getSonePersonalDetails(),getUsiDetails(),getHelperTextForPage('Usi Details'), getTemporaryCustomMessages('USI_OUTAGE')]).then(([personalDetails, usiDetails, helperText, tempMessages]) => {
      setTopCallout(helperText.data.length > 0 ? helperText.data[0].attributes.body.value : topCallout)

      if (personalDetails.legalLastName !== null && personalDetails.legalLastName !== '') {
        usiDetails.firstFamilyNameIndicator = 'Y'
      }
      if (usiDetails.validationOutcome === 'VALID') {
        usiDetails.usiVerified = true
      }

      const updatedForm = {
        ...form,
        ...usiDetails,
        ...personalDetails,
        offshoreFlag: getAttributeCourseStaticInfo('isOffshoreFlag')
      };

      setForm(updatedForm);
      setFormLoaded(true);
      setTempMessage(tempMessages.length ? tempMessages[0] : null)
    })
    .catch((err) => {
      setFormFailedLoading(true);
    })

    trackPageView()
  },[props.personalDetails])

  const trackPageView = () => {
    getStudentProgress(getCourseId()).then(progress => {
      const processId = progress && progress.id ? progress.id : undefined

      const lastPageAccessTime = getLastPageAccessTime()
      const pageAccessTime = new Date()

      window.dataLayer.push({
        event: 'custom.form.step.view',
        group: 'Enrol',
        processId: processId,
        step: {
          sequence: 4,
          label: 'USI details',
          variation: undefined
        },
        info: {
          time: lastPageAccessTime ? differenceInSeconds(pageAccessTime, new Date(lastPageAccessTime)) : undefined
        },
        data: {
          value: undefined,
          courseId: getCourseId()
        }
      })

      sessionStorage.setItem('LAST_PAGE_ACCESS_TIME', JSON.stringify(pageAccessTime))
    })
  }

  const handleSubmit = ({form, valid, errors}) => {
    if (valid) {
      const newUsiDetails = {
        studentId: form.studentId,
        usiNo: form.usiNo,
        givenName: form.legalFirstName,
        surname: form.legalLastName,
        singleName: form.singleName,
        gender: form.gender,
        dateOfBirth: form.dateOfBirth
      }

      setSaving(true)

      putUsiDetails(newUsiDetails)
        .then(response => {
          setSaving(false)

          let status = response.status ? response.status.toUpperCase() : ''

          if (status === 'VALID' || status === 'NA') {
            if (status === 'VALID') {
              alert('USI details successfully verified.')
            }
            setForm({...form, hasErrorOnValidation: false })
            progressForm()
          } else {
            setForm({...form, hasErrorOnValidation: true, showValidationMessage: true })
            setInterval(() => {
              setForm({...form, showValidationMessage: false })
            }, 5000)
          }
        })
        .catch(({ response: { status, data: { errorCode, errorMessage } } }) => {
          setSaving(false)
          setForm({...form, hasErrorOnValidation: true})

          if (status === 400) {
            setForm({...form, showValidationMessage: true })
            setInterval(() => {
              setForm({...form, showValidationMessage: false })
            }, 5000)
          } else {
            alert('System has encountered an error. Please try again or contact VUHQ for assistance.')
          }
        })
    } else {
      form.usiNo && form.usiNo.length === 10 ? progressForm() : null
      window.scrollTo(0, 0)
    }
  }

  const progressForm = () => {
    const currentStepIndex = getStepIndexByUrl(props.location.pathname)

    updateStepProgress(currentStepIndex)
    updateDBStepProgress(currentStepIndex)

    props.history.push(getStepByIndex(currentStepIndex + 1).url)
  }

  return (
   formFailedLoading ?  
    (
      <ErrorCard
        title="Cannot Load USI Details" 
        description="Sorry, we're unable to load the financial support information at the moment." 
        showContactInfo={true} 
      />
    ) :
    (
      <div className="page page_fullWidth form form_additional_details">
        <div className="mobile-margin">
          {tempMessage ? (
            <div className="tile-notification">
              <h2>
                <Notifications class="btn-point-events" /> {tempMessage.title}
              </h2>
              {parse(tempMessage.value)}
            </div>
          ) : null}
          {formLoaded && !form.usiVerified && parse(topCallout)}
          {!formLoaded ? (
            <Loading />
          ) : (
            <UsiDetailsForm
              saving={saving}
              values={form}
              handleSubmit={handleSubmit}
              progressForm={progressForm}
              errorOnValidation={form.hasErrorOnValidation}
              showValidationMessage={form.showValidationMessage}
            />
          )}
        </div>
      </div>
    )
  )
}
export default UsiDetails;